module.exports = __webpack_public_path__ + "static/media/kyle.b907dc75.png";